module.exports = __webpack_public_path__ + "img/step2.4887eac8.png";